import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';
import { Consulta } from 'src/app/models/consulta';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { Unidade } from 'src/app/models/Unidade';
import { CiacService } from 'src/app/services/http/ciac.service';

@Component({
  selector: 'app-form-consulta-composta',
  templateUrl: './form-consulta-composta.component.html',
  styleUrls: ['./form-consulta-composta.component.scss']
})
export class FormConsultaCompostaComponent implements OnInit {

  nomeConsulta = new FormControl('', [Validators.required]);

  listaConsultas: Consulta[] = [];
  listaConsultasCredito: Consulta[] = [];
  totalConsultas = 0;
  id: any;
  uuid: any;
  usuario: any;
  combinada: boolean;
  nomeTipo: string;
  idUnidade: null;
  unidadeSelecionada = new Unidade();
  listaPermissao: any;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private modalMsgService: ModalMsgService,
    private unidadeService: UnidadeService,
    private consultaService: ConsultaService,
    private ciacService: CiacService) {

    this.idUnidade = this.activatedRoute.snapshot.params.idUnidade || null;
    this.combinada = this.activatedRoute.snapshot.data['combinada'];
    this.nomeTipo = this.combinada ? 'combinada' : 'composta';

    if (!this.idUnidade){
      this.loginService.getLogIn().pipe(first()).subscribe(l => {
        this.idUnidade = l.unidade.uuid;
      });
    }

    this.ciacService.getConsultaCreditoLaudo().then(c => this.listaConsultasCredito = c);
    this.listaPermissao = this.consultaService.listaConsulta().then(r => {
      this.listaPermissao = r;
      this.listaConsultas = [...this.listaPermissao];
    });
    this.unidadeService.getUnidade(this.idUnidade).then(u => {
      this.unidadeSelecionada = u.unidade;
      this.uuid = this.activatedRoute.snapshot.params.uuid || null;
      if (this.uuid != null) {
        this.consultaService.getComposta(this.uuid).then(composta => {
          this.id = composta.id;
          this.totalConsultas += composta.consultas.length;
          if( this.id != 984 ) {
            this.listaConsultas = this.listaConsultas.map( c => ({...c, checked: composta.consultas.find( cc => cc.id == c.id ) != null}) );
            this.listaConsultasCredito = this.listaConsultasCredito.map( c => ({...c, checked: composta.consultas.find( cc => cc.id == c.id ) != null}) );
            this.nomeConsulta.setValue(composta.nome);
            const credito = this.listaConsultasCredito.find(c => c.checked);
            if(credito) {
              this.selecionarCredito(true, credito);
            }
          }else {
            this.listaConsultas = [];
            this.nomeConsulta.setValue(composta.nome);
          }
        });
      }
    });

  }

  selecionarCredito(checked, consulta) {
    this.listaConsultasCredito.forEach( c => {
      c.disabled = checked;
    });
    consulta.checked = checked;
    consulta.disabled = false;
  }

  ngOnInit() {
  }

  count() {
    this.totalConsultas = 0;
    this.listaConsultas.forEach(c => {
      if (c.checked) this.totalConsultas++;
    });

    this.listaConsultasCredito.forEach(c => {
      if (c.checked) this.totalConsultas++;
    });
  }

  concluir() {

    // Adiciona uma nova consulta composta/combinada
    if(this.idUnidade && this.uuid == null){
      this.salvarCompostaUnidade();
    }

    // Verifica se existe um ID passado pela URL
    if(this.uuid){
      this.editar();
    }
    // else {
    //   this.salvar();
    // }
  }

  salvar() {
    if (this.nomeConsulta.invalid || this.totalConsultas <= 0) return;

    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Adicionar consulta ' + this.nomeTipo;
    modalRef.result.then(justificativa => {
      if (justificativa) {
        // const consultas = this.listaConsultas.map(c => {
        //   let result = { ...c, statusConsulta: c.checked };
        //   return result;
        // });

        let consultasCredito = this.listaConsultasCredito.map(c => {
          let result = { ...c, statusConsulta: c.checked };
          delete c.checked;
          delete c.disabled;
          return result;
        });

        const consultasVeiculo = this.listaConsultas.map(c => {
          let result = { ...c, statusConsulta: c.checked };
          delete c.checked;
          delete c.disabled;
          return result;
        });

        const consultas = [...consultasVeiculo, ...consultasCredito];

        this.consultaService[this.combinada ? 'adicionarCombinada' : 'adicionarComposta']({ nome: this.nomeConsulta.value, consultas: consultas }, justificativa)
          .then(result => {
            this.modalMsgService.openDialog('Consulta ' + this.nomeTipo + 'adicionada com sucesso','', 'success').finally(() => this.navigateBack());
          }).catch(result => {
            this.modalMsgService.openDialog('Erro ao efetuar transação',
              'Ocorreu um erro ao se comunicar com a base de dados, tente novamente mais tarde, ou entre contato com o responsavel', 'danger');
          });
      } else {
        this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger');
      }
    }).catch(result => {
      this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger');
    });
  }

  editar() {
    if (this.id == null || this.nomeConsulta.invalid || this.totalConsultas <= 0) return;

    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Editar consulta ' + this.nomeTipo;
    modalRef.result.then(result => {
      if (result) {
        // const consultas = this.listaConsultas.map(c => {
        //   let result = { ...c, statusConsulta: c.checked };
        //   delete c.checked;
        //   delete c.disabled;
        //   return result;
        // });

        let consultasCredito = this.listaConsultasCredito.map(c => {
          let result = { ...c, statusConsulta: c.checked };
          delete c.checked;
          delete c.disabled;
          return result;
        });

        const consultasVeiculo = this.listaConsultas.map(c => {
          let result = { ...c, statusConsulta: c.checked };
          delete c.checked;
          delete c.disabled;
          return result;
        });

        const consultas = [...consultasVeiculo, ...consultasCredito];

        let data = {unidade: this.unidadeSelecionada,  nome: this.nomeConsulta.value, uuid: this.uuid, idUnidade: this.unidadeSelecionada.id, combinada: this.combinada, consultas: consultas };

          if(data.combinada != true && data.combinada == false){
            this.consultaService.editarComposta({ uuid: data.uuid, nome: data.nome, consultas: data.consultas, idUnidadeConsultaComposta: data.idUnidade}, result)
              .then(result => {
                this.modalMsgService.openDialog('Consulta ' + this.nomeTipo + ' alterada com sucesso', '', 'success')
                  .then(result => {}).catch(result => {})
                  .finally(() => this.navigateBack());
              });
          }

          if(data.combinada == true) {
            this.consultaService.editarComposta({ uuid: data.uuid, nome: data.nome, consultas: data.consultas, combinada: true, idUnidadeConsultaComposta: data.idUnidade}, result)
              .then(result => {
                this.modalMsgService.openDialog('Consulta ' + this.nomeTipo + ' alterada com sucesso', '', 'success')
                  .then(result => {}).catch(result => {})
                  .finally(() => this.navigateBack());
              });
          }

      } else {
        this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger');
      }
    }).catch(result => {
      this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger');
    });
  }

  salvarCompostaUnidade() {
    if (this.nomeConsulta.invalid || this.totalConsultas <= 0) return;

    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Adicionar consulta ' + this.nomeTipo;
    modalRef.result.then(result => {
      if (result) {

        let consultasCredito = this.listaConsultasCredito.map(c => {
          let result = { ...c, statusConsulta: c.checked };
          delete c.checked;
          delete c.disabled;
          return result;
        });

        const consultasVeiculo = this.listaConsultas.map(c => {
          let result = { ...c, statusConsulta: c.checked };
          delete c.checked;
          delete c.disabled;
          return result;
        });

        const consultas = [...consultasVeiculo, ...consultasCredito];

        let data = {unidade: this.unidadeSelecionada,  nome: this.nomeConsulta.value, idUnidade: this.unidadeSelecionada.id, combinada: this.combinada, consultas: consultas };

        if(data.combinada != true && data.combinada == false){
          this.consultaService.adicionarCompostaUnidade(data, result)
          .then(result => {
            this.modalMsgService.openDialog('Consulta ' + this.nomeTipo + ' adicionada com sucesso','', 'success').finally(() => this.navigateBack());
          }).catch(result => {
            this.modalMsgService.openDialog('Erro ao efetuar transação',
              'Ocorreu um erro ao se comunicar com a base de dados, tente novamente mais tarde, ou entre contato com o responsavel', 'danger');
          });
        }

        if(data.combinada == true) {
          this.consultaService.adicionarCombinada(data, result)
          .then(result => {
            this.modalMsgService.openDialog('Consulta ' + this.nomeTipo + ' adicionada com sucesso','', 'success').finally(() => this.navigateBack());
          }).catch(result => {
            this.modalMsgService.openDialog('Erro ao efetuar transação',
              'Ocorreu um erro ao se comunicar com a base de dados, tente novamente mais tarde, ou entre contato com o responsavel', 'danger');
          });
        }

      } else {
        this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger');
      }
    }).catch(result => {
      this.modalMsgService.openDialog('Erro ao efetuar transação', 'Nenhuma justificativa foi informada', 'danger');
    });
  }

  navigateBack() {
    if(this.combinada) {
      this.router.navigate(['consulta', 'combinada', 'listar']);
    } else {
      this.router.navigate(['consulta', 'composta', 'listar']);
    }
  }

}
